import { Typography } from "@mui/material";
import { theme } from "../../../Common/UI/styles/theme";

export default function ReleaseTwoPointFour() {
  return (
    <>
      <Typography variant="h6" className="release-title" color={theme.palette.error.main}>
        RELEASE 2.5 – May 12th , 2025
      </Typography>
      <ul>
        <li>
          Dashboard Home – <b>NEW</b> Website Monitoring Widget
          <ul>
            <li style={{ listStyleType: "circle" }}>
              Available now is real time monitoring of our Website along with our Ordering Site. Automated testing will be running every 30 min and
              ensuring that our sites are up and running
            </li>
            <li style={{ listStyleType: "circle" }}>
              If a test fails, automated email will be generated and sent to HD along with updating the status on the dashboard
            </li>
          </ul>
        </li>
        <li>
          Store 411 – POS Terminals Tab
          <ul>
            <li style={{ listStyleType: "circle" }}>
              This tab is now renamed to <b>POS Terminals & Kiosks. NEW</b> For stores that have Kiosks, you will be able to see that information under this
              tab.
            </li>
            <li style={{ listStyleType: "circle" }}>
              In the Main Store 411 page, users should also be able to filter on Kiosks and export as needed
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
}
